import { ApiModel }          from '../../app-lite/api/models/api.model';
import { CodeTypeModel }     from '../../app-lite/core/models/code-type';
import { SessionService } from '../../app-lite/sessions/session.service';

export class AdminReportsCtrl {
  accountingErrors = {
    accounting: 'X',
    beginDate : '*',
    csv       : () => `${ this.API.url }/reports/jasper_accounting_events/csv/${ this.accountingErrors.beginDate }/${ this.accountingErrors.endDate }/${ this.accountingErrors.accounting }`,
    endDate   : '*',
    pdf       : () => `${ this.API.url }/reports/jasper_accounting_events/pdf/${ this.accountingErrors.beginDate }/${ this.accountingErrors.endDate }/${ this.accountingErrors.accounting }.pdf`,
  };

  countChangeLogs = {
    beginDate: '*',
    csv      : () => `${ this.API.url }/reports/jasper_system_change_logs/csv/${ this.countChangeLogs.beginDate }/${ this.countChangeLogs.endDate }`,
    endDate  : '*',
    pdf      : () => `${ this.API.url }/reports/jasper_system_change_logs/pdf/${ this.countChangeLogs.beginDate }/${ this.countChangeLogs.endDate }.pdf`,
  };

  internalNoInvoice = {
    beginDate: '*',
    csv      : () => `${ this.API.url }/reports/jasper_internal_no_invoice/csv/${ this.internalNoInvoice.beginDate }/${ this.internalNoInvoice.endDate }`,
    endDate  : '*',
    pdf      : () => `${ this.API.url }/reports/jasper_internal_no_invoice/pdf/${ this.internalNoInvoice.beginDate }/${ this.internalNoInvoice.endDate }.pdf`,
  };

  internalNoLogin = {
    beginDate: '*',
    csv      : () => `${ this.API.url }/reports/jasper_internal_no_login/csv/${ this.internalNoLogin.beginDate }/${ this.internalNoLogin.endDate }`,
    endDate  : '*',
    pdf      : () => `${ this.API.url }/reports/jasper_internal_no_login/pdf/${ this.internalNoLogin.beginDate }/${ this.internalNoLogin.endDate }.pdf`,
  };

  systemActivityLogs = {
    beginDate   : '*',
    csv         : () => `${ this.API.url }/reports/jasper_system_activity_logs/csv/${ this.systemActivityLogs.timeDuration || 1 }/${ this.sessionObjAPI.company().id }/${ this.systemActivityLogs.beginDate }/${ this.systemActivityLogs.endDate }`,
    endDate     : '*',
    pdf         : () => `${ this.API.url }/reports/jasper_system_activity_logs/pdf/${ this.systemActivityLogs.timeDuration || 1 }/${ this.sessionObjAPI.company().id }/${ this.systemActivityLogs.beginDate }/${ this.systemActivityLogs.endDate }.pdf`,
    timeDuration: 1
  };

  systemErrorLogs = {
    beginDate: '*',
    csv      : () => `${ this.API.url }/reports/jasper_system_error_logs/csv/${ this.systemErrorLogs.beginDate }/${ this.systemErrorLogs.endDate }`,
    endDate  : '*',
    pdf      : () => `${ this.API.url }/reports/jasper_system_error_logs/pdf/${ this.systemErrorLogs.beginDate }/${ this.systemErrorLogs.endDate }.pdf`,
  };

  userStatistics = {
    beginDate: '*',
    csv      : () => `${ this.API.url }/reports/jasper_user_statistics/pdf/${ this.userStatistics.beginDate }/${ this.userStatistics.endDate }.pdf`,
    endDate  : '*',
    pdf      : () => `${ this.API.url }/reports/jasper_user_statistics/csv/${ this.userStatistics.beginDate }/${ this.userStatistics.endDate }`
  };

  constructor (
    private API           : ApiModel,
    public accountingTypes: Array<CodeTypeModel>,
    private sessionObjAPI : SessionService
  ) {}
}
